var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup18929(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.594,
    height: 9.752,
    viewBox: "0 0 9.594 9.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18929",
    "data-name": "Group 18929",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18927",
    "data-name": "Group 18927",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M15.145,11.068l-3.69-3.687a.7.7,0,0,1,.987-.984l4.181,4.178a.7.7,0,0,1,.02.961l-4.2,4.207a.7.7,0,1,1-.987-.984Z",
    transform: "translate(-7.232 -6.194)",
    fill: "#0e2129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back-2",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M14.058,9.707,11.4,7.05a.5.5,0,0,1,.711-.709l3.013,3.011a.5.5,0,0,1,.015.693l-3.026,3.032a.5.5,0,1,1-.711-.709Z",
    transform: "translate(-11.251 -4.586)",
    fill: "#0e2129"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup18929);
export default __webpack_public_path__ + "static/media/Group 18929.000e2985f367d90ed39b6d9d91554b40.svg";
export { ForwardRef as ReactComponent };